import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CategoryBar.css";


const CategoryBar = ({ sezioni, onClick }) => {
  return (
    <div className="category-bar">
      <div className="category-bar-content">
        {sezioni.map((sezione) => (
          <div
            key={sezione.id}
            className="category-link"
            onClick={() => onClick(sezione)}
          >
            {sezione.titolo}
          </div>
        ))}
      </div>
    </div>
  );
};


export default CategoryBar;


// <Link key={sezione.id} to={`/sezione/${sezione.titolo}`} className="category-link">
//                 {sezione.titolo}
//                 </Link>